module.exports = __webpack_public_path__ + "static/banner-c72cfd3fc23f632d786dd07c668c0231.jpeg";